var escape = require("../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#NotFoundComponent{height:600px;background-size:auto 100%;background-position:50%;background-repeat:no-repeat;background-image:url(" + escape(require("../assets/images/404.jpg")) + ")}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c67b1fea","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/NotFoundComponent.vue
// module id = 200
// module chunks = 0